import { gql } from '@apollo/client';

export interface ImportExercisesFromCourseMutationVariables {
  courseId: string;
  subjectId: string;
  input: {
    exercises: string[];
  };
}

export const importExercisesFromCourseMutation = gql`
  mutation ImportExercisesFromCourseMutation($courseId: String!, $subjectId: String!, $input: ImportExercisesFromCourseMutationInput!) {
    exercises(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/import", method: "POST") {
      NoResponse
    }
  }
`;
